import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=3e5b51cf&scoped=true&"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=3e5b51cf&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5b51cf",
  null
  
)

export default component.exports